<template>
  <div class="content-container">
    <div uk-grid>
      <div class="uk-width-2-3">
        <div :class="{'uk-text-left': !mobileWidth, 'mobile-description': mobileWidth}">
          <h2>{{heading}}</h2>
        </div>
      </div>
      <div class="uk-width-1-3">
        <div class="uk-text-right">
          <span v-if="!mobileWidth" class="see-more-text add-pointer" @click="redirect">+ {{$t('general.seeMore')}}</span>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div v-if="!content.length" class="spinner-margin uk-flex uk-flex-center">
      <spinner></spinner>
    </div>
    <div v-else>
      <div class="uk-visible@m uk-child-width-expand uk-grid-small" uk-grid>
        <div v-for="item in rowContent">
          <card :item="item"></card>
        </div>
      </div>
      <div class="uk-hidden@m">
        <slider :content="content" :screenWidth="screenWidth"></slider>
      </div>
    </div>
  </div>
</template>

<script>
  import Router from '../../../router/index'
  import Spinner from '../../ui-components/spinner/spinner'
  import {mapMutations} from 'vuex'
  import card from './category-card'
  import slider from './category-slider'

  export default {
    name: 'home-content-category',
    props: ['content', 'heading', 'screenWidth', 'type'],
    data() {
      return {
        mobileWidth: false
      }
    },
    components: {
      card,
      Spinner,
      slider
    },
    methods: {
      ...mapMutations(['updateSelectedCategory']),
      redirect() {
        this.updateSelectedCategory(this.type)
        Router.push('search')
      },
      resolveWindowWidth() {
        this.mobileWidth = this.screenWidth < 1024
      }
    },
    computed: {
      rowContent() {
        if (this.screenWidth <= 1024) {
          return this.content.slice(0, 6)
        } else if (this.screenWidth <= 1366) {
          return this.content.slice(0, 5)
        } else {
          return this.content
        }
      }

    },
    created() {
      this.resolveWindowWidth()
      window
        .addEventListener(
          'resize',
          this.resolveWindowWidth)
    },
    destroyed() {
      window
        .removeEventListener(
          'resize',
          this.resolveWindowWidth)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  @import '../../../styles/colours';

  .content-container {
    margin-top: 35px;
  }

  h2 {
    font-size: 22px;
    color: $content-text;
    margin-bottom: 0;
  }

  .divider {
    height: 2px;
    opacity: 0.2;
    background: $slate;
  }

  .see-more-text {
    color: $content-link-blue;
    font-size: 18px;
  }

  .spinner-margin {
    margin-top: 15px;
  }

  .uk-card-body {
    padding: 0;
  }

  .mobile-description {
    padding-left: 18px;

    .content-heading {
      font-size: 18px;
    }
  }
</style>
